import { Icon, icons } from "../../../components/Icon";

export const Logo = ({ width = "200px", height = "30px" }) => {
  return (
    <Icon
      component={icons.logo}
      width={width}
      height={height}
      mobileWidth="150px"
      mobileHeight="25px"
    />
  );
};
